const duringDataFaqs = [
    {
        id:"1",
        question : "Will the Movers Take Any Extra Items I Have?",
        answer :"Yes, we can take additional items. However, if you have last-minute requests that significantly increase the volume of your move, please inform us before our crew arrives so we can come prepared and adjust our schedule accordingly.",
        points:[
        ]
    },
    {
        id:"2",
        question : "How Big Are Your Trucks?",
        answer :"We own and operate a large commercial fleet of moving trucks to accommodate moves of all sizes. Our truck sizes include:",
        points:[
            "16ft – Ideal for a studio or one-bedroom apartment",
            "20ft – Suitable for a two-bedroom apartment",
            "26ft – Best for a three-bedroom (or larger) apartment or house",
            "48ft – Designed for long-distance moves",
        ]
    },
    {
        id:"3",
        question : "Will the Movers Uninstall My AC Unit and TV?",
        answer :"No, M Power Moving Services does not offer AC or TV mounting/unmounting services. We recommend hiring specialized professionals to handle these tasks before your moving day.",
        points:[
        ]
    },
]

export default duringDataFaqs;